import { z } from 'zod';

/** Where one template body parameter comes from. */
export const paramSourceSchema = z.discriminatedUnion('source', [
  z.object({ source: z.literal('literal'), value: z.string().trim().min(1).max(200) }),
  z.object({ source: z.literal('customer.firstName') }),
  z.object({ source: z.literal('customer.fullName') }),
  z.object({ source: z.literal('order.number') }),
  z.object({ source: z.literal('order.total') }),
  z.object({ source: z.literal('order.currency') }),
  /** A payment link for this order, created when the message is sent (needs Razorpay). */
  z.object({ source: z.literal('order.paymentLink') }),
  /** Shipment details from the store's fulfillment ("-" when the store sent none). */
  z.object({ source: z.literal('order.carrier') }),
  z.object({ source: z.literal('order.trackingNumber') }),
  z.object({ source: z.literal('order.trackingUrl') }),
  z.object({ source: z.literal('store.name') }),
  /** Back-in-stock and price-drop alerts. */
  z.object({ source: z.literal('product.title') }),
  z.object({ source: z.literal('product.url') }),
  z.object({ source: z.literal('product.price') }),
  z.object({ source: z.literal('product.oldPrice') }),
]);
export type ParamSource = z.infer<typeof paramSourceSchema>;
export const paramsSchema = z.array(paramSourceSchema).max(20);
